const InputField = (props) => {
  const inputProps = { ...props, type: props.type || "text" };
  return <input {...inputProps} className="form-control bg-light bg-opacity-50 border-light py-2" />;
};

export default InputField;
